"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var LibZLVersions_1 = require("./LibZLVersions");
// @ts-ignore
global.jQuery = jquery_1.default;
// @ts-ignore
global.$ = jquery_1.default;
var FullScreenMobileDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\theight: 100%;\n\toverflow: hidden;\n\n\t@media ", " {\n\t\tposition: fixed;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tz-index: 800;\n\t\toverflow: visible;\n\t\tdisplay: inline;\n\t\tbackground-color: white;\n\t}\n\n"], ["\n\theight: 100%;\n\toverflow: hidden;\n\n\t@media ", " {\n\t\tposition: fixed;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tz-index: 800;\n\t\toverflow: visible;\n\t\tdisplay: inline;\n\t\tbackground-color: white;\n\t}\n\n"])), function (props) { return props.theme.breakpoints.fullScreenStream; });
var StreamContainer = /** @class */ (function (_super) {
    __extends(StreamContainer, _super);
    function StreamContainer(props) {
        var _this = _super.call(this, props) || this;
        if (typeof window !== 'undefined' && window.libZL === undefined) {
            window.libZL = null;
            var script = document.createElement('script');
            var params = undefined;
            try {
                params = new URLSearchParams(window.location.search);
            }
            catch (_a) { }
            var libzl = params && params.get("libzl");
            if (libzl) {
                libzl = decodeURIComponent(libzl);
            }
            console.log("Requested LibZL: " + libzl);
            if (libzl === "local") {
                script.src = "http://localhost:8023/build/web/libzl.js";
            }
            else if (libzl === null || libzl === void 0 ? void 0 : libzl.startsWith("https://libzl-dev.zlthunder.net/")) {
                script.src = libzl;
            }
            else {
                if (libzl && LibZLVersions_1.LibZLStreams[libzl] === undefined && LibZLVersions_1.LibZLVersionHashes[libzl] === undefined) {
                    console.error("Ignoring Unknown LibZL Version: " + libzl);
                    libzl = undefined;
                }
                if (!libzl) {
                    if (window.location.hostname.includes("-dev.")) {
                        libzl = "dev";
                    }
                    else if (window.location.hostname.includes("-test.") || window.location.hostname.includes("-prerelease.")) {
                        libzl = "prelive";
                    }
                    else {
                        libzl = "live";
                    }
                }
                if (LibZLVersions_1.LibZLStreams[libzl]) {
                    libzl = LibZLVersions_1.LibZLStreams[libzl];
                }
                script.src = "https://libzl.zlthunder.net/v3/version/" + libzl + "/libzl.js";
                script.integrity = LibZLVersions_1.LibZLVersionHashes[libzl] || "";
            }
            script.crossOrigin = "anonymous";
            script.onload = function () {
                /*global LibZL:true*/
                // @ts-ignore
                window.libZL = new LibZL();
            };
            var parentElement = document.getElementsByTagName('head')[0];
            parentElement.appendChild(script);
        }
        return _this;
    }
    StreamContainer.prototype.render = function () {
        if (this.props.fillLandscapeMobile === undefined || this.props.fillLandscapeMobile) {
            return (react_1.default.createElement(FullScreenMobileDiv, { id: this.props.id }, this.props.children));
        }
        else {
            return (react_1.default.createElement("div", __assign({}, this.props, { style: { height: "100%", "overflow": "hidden" } })));
        }
    };
    StreamContainer.propTypes = {
        /** If this is undefined or true, this div will pop to full screen when on mobile landscape */
        fillLandscapeMobile: prop_types_1.default.bool
    };
    return StreamContainer;
}(react_1.Component));
exports.default = styled_components_1.withTheme(StreamContainer);
var templateObject_1;
//# sourceMappingURL=StreamContainer.js.map